export default __webpack_public_path__ + "static/media/login.b373a8a5.png";